import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = {
    key: 0,
    "data-bs-toggle": "modal",
    "data-bs-target": "#duplicateModal",
    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-flex align-items-center justify-content-center me-10 mb-10 mb-lg-0 text-nowrap",
    type: "button"
};
const _hoisted_5 = {
    key: 1,
    class: "me-3"
};
const _hoisted_6 = { class: "form-label text-muted small mb-1" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_10 = { class: "table-responsive" };
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_13 = { class: "d-flex align-items-center" };
const _hoisted_14 = { class: "form-check mb-0 me-2" };
const _hoisted_15 = ["checked"];
const _hoisted_16 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_17 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_18 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_19 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_20 = { key: 0 };
const _hoisted_21 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_23 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_24 = { class: "form-check mb-0 text-capitalize" };
const _hoisted_25 = ["value"];
const _hoisted_26 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_31 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_32 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_33 = ["src"];
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_35 = { class: "form-check form-switch" };
const _hoisted_36 = ["checked", "onChange"];
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_38 = { class: "dropdown" };
const _hoisted_39 = { class: "dropdown-menu" };
const _hoisted_40 = { key: 0 };
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { key: 1 };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { key: 2 };
const _hoisted_46 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_47 = { class: "mb-0 text-paragraph" };
const _hoisted_48 = { class: "mt-15 mt-md-0" };
const _hoisted_49 = { class: "pagination mb-0" };
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_53 = { class: "modal-content" };
const _hoisted_54 = { class: "modal-footer" };
const _hoisted_55 = {
    class: "modal fade",
    id: "duplicateModal",
    tabindex: "-1",
    "aria-labelledby": "duplicateModalLabel",
    "aria-hidden": "true"
};
const _hoisted_56 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_57 = { class: "modal-content" };
const _hoisted_58 = { class: "modal-header bg-white border-bottom-0" };
const _hoisted_59 = {
    class: "modal-title",
    id: "duplicateModalLabel"
};
const _hoisted_60 = { class: "modal-body text-center" };
const _hoisted_61 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_62 = { key: 1 };
const _hoisted_63 = {
    key: 2,
    class: "mt-3"
};
const _hoisted_64 = { class: "progress" };
const _hoisted_65 = ["aria-valuenow"];
const _hoisted_66 = {
    key: 3,
    class: "text-start mt-3"
};
const _hoisted_67 = {
    key: 0,
    class: "alert alert-success"
};
const _hoisted_68 = {
    key: 1,
    class: "alert alert-warning"
};
const _hoisted_69 = {
    key: 0,
    class: "mt-2 mb-0"
};
const _hoisted_70 = {
    key: 0,
    class: "modal-footer"
};
const _hoisted_71 = ["disabled"];
const _hoisted_72 = {
    key: 1,
    class: "modal-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-flex align-items-center justify-content-center me-10 mb-10 mb-lg-0 text-nowrap",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('category.addCategory')) + " ", 1),
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ]),
                    (_ctx.selectedItems.length > 0)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
                            _createTextVNode(" Dupliquer (" + _toDisplayString(_ctx.selectedItems.length) + ") ", 1),
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-copy position-relative ms-5 fs-12" }, null, -1))
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('lists.restaurant')), 1),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.selectedRestaurant,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                options: _ctx.restaurantOptions,
                                label: "name",
                                reduce: (restaurant) => restaurant.id,
                                placeholder: _ctx.$t('lists.selectRestaurant'),
                                class: "restaurant-select",
                                onInput: _ctx.onRestaurantChange
                            }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('forms.searchCategoryPlaceholder'),
                            onInput: _cache[3] || (_cache[3] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_8), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("input", {
                                                class: "form-check-input shadow-none",
                                                type: "checkbox",
                                                checked: _ctx.isAllSelected,
                                                onChange: _cache[5] || (_cache[5] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                                            }, null, 40, _hoisted_15)
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.id')), 1)
                                    ])
                                ]),
                                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('lists.name')), 1),
                                _cache[16] || (_cache[16] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Position ", -1)),
                                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('lists.icon')), 1),
                                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('lists.createdAt')), 1),
                                _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('lists.status')), 1),
                                _cache[17] || (_cache[17] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                    _createElementVNode("td", _hoisted_21, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading &&
                                    _ctx.allRestaurantCategorie.length > 0 &&
                                    (_ctx.userRole === _ctx.UserRole.RESTAURANT || _ctx.userRole === _ctx.UserRole.ADMIN ||
                                        _ctx.userRole === _ctx.UserRole.FRANCHISE))
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allRestaurantCategorie, (cat, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: cat.id
                                        }, [
                                            _createElementVNode("th", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.selectedItems) = $event)),
                                                            value: cat.id
                                                        }, null, 8, _hoisted_25), [
                                                            [_vModelCheckbox, _ctx.selectedItems]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(cat))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(cat.id)), 9, _hoisted_27)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_28, _toDisplayString(cat.name), 1),
                                            _createElementVNode("td", _hoisted_29, _toDisplayString(cat.position !== undefined && cat.position !== null ? cat.position : '-'), 1),
                                            _createElementVNode("th", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("div", _hoisted_32, [
                                                        _createElementVNode("img", {
                                                            src: _ctx.getProductImageUrl(cat),
                                                            class: "rounded-circle me-8",
                                                            width: "24",
                                                            height: "24"
                                                        }, null, 8, _hoisted_33)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.convertDateCreate(cat.created_at)), 1),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        checked: _ctx.getIsActiveBoolean(cat.isActive),
                                                        onChange: ($event) => (_ctx.handleToggleChange(cat, $event))
                                                    }, null, 40, _hoisted_36)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                    _cache[21] || (_cache[21] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_39, [
                                                        (_ctx.userRole != _ctx.UserRole.RESTAURANT)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                                                _createElementVNode("a", {
                                                                    class: "dropdown-item d-flex align-items-center",
                                                                    href: "javascript:void(0);",
                                                                    onClick: ($event) => (_ctx.selectForDetail(cat))
                                                                }, [...(_cache[18] || (_cache[18] = [
                                                                        _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                                        _createTextVNode(" Voir", -1)
                                                                    ]))], 8, _hoisted_41)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (_ctx.userRole != _ctx.UserRole.RESTAURANT)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                                                _createElementVNode("a", {
                                                                    class: "dropdown-item d-flex align-items-center",
                                                                    href: "javascript:void(0);",
                                                                    onClick: ($event) => (_ctx.selectForDetail(cat))
                                                                }, [...(_cache[19] || (_cache[19] = [
                                                                        _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                                                        _createTextVNode(" Editer", -1)
                                                                    ]))], 8, _hoisted_43)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDelete(cat))
                                                            }, [...(_cache[20] || (_cache[20] = [
                                                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Supprimer", -1)
                                                                ]))], 8, _hoisted_44)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                                        _createVNode(_component_EmptyTable, {
                                            message: "Aucune categorie pour le moment",
                                            colspan: 8,
                                            textClass: "text-muted"
                                        })
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_48, [
                        _createElementVNode("ul", _hoisted_49, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_50)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[23] || (_cache[23] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                    _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"confirmModalLabel\"> Confirmation de suppression </h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body text-center\"><i class=\"fas fa-exclamation-triangle warning-icon\"></i><p class=\"mb-0\"> Êtes-vous sûr de vouloir supprimer cette catégorie ?<br>Cette action est irrevesible. </p></div>", 2)),
                    _createElementVNode("div", _hoisted_54, [
                        _cache[25] || (_cache[25] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            "data-bs-dismiss": "modal"
                        }, [
                            _createElementVNode("i", { class: "fas fa-times me-2" }),
                            _createTextVNode("Annuler ")
                        ], -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.confirmationDeleteAction(_ctx.categorieSelected))),
                            "data-bs-dismiss": "modal"
                        }, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1),
                                _createTextVNode("Supprimer ", -1)
                            ]))])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("h5", _hoisted_59, _toDisplayString(_ctx.duplicationResult ? 'Résultat de la duplication' : `Dupliquer ${_ctx.selectedItems.length} catégories`), 1),
                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                        (!_ctx.duplicationResult)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_61, " Sélectionnez le restaurant cible : "))
                            : _createCommentVNode("", true),
                        (!_ctx.isDuplicating && !_ctx.duplicationResult)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.duplicationTargetRestaurants,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.duplicationTargetRestaurants) = $event)),
                                    options: _ctx.restaurantOptions.filter(r => r.id !== _ctx.selectedRestaurant),
                                    label: "name",
                                    multiple: "",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: "Sélectionnez un ou plusieurs restaurants",
                                    class: "restaurant-select text-start"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ]))
                            : (_ctx.isDuplicating)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _createElementVNode("p", null, "Duplication en cours... " + _toDisplayString(_ctx.duplicationProgress) + "%", 1),
                                    _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", {
                                            class: "progress-bar progress-bar-striped progress-bar-animated bg-success",
                                            role: "progressbar",
                                            style: _normalizeStyle('width: ' + _ctx.duplicationProgress + '%'),
                                            "aria-valuenow": _ctx.duplicationProgress,
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                        }, null, 12, _hoisted_65)
                                    ])
                                ]))
                                : (_ctx.duplicationResult)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        (_ctx.duplicationResult.success > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-check-circle me-2" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.duplicationResult.success) + " élément(s) dupliqué(s) avec succès. ", 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.duplicationResult.failed > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.duplicationResult.failed) + " élément(s) ignoré(s) ou en échec : ", 1),
                                                (_ctx.duplicationResult.errors && _ctx.duplicationResult.errors.length > 0)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_69, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicationResult.errors, (err, i) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(err), 1));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                    ]),
                    (!_ctx.isDuplicating && !_ctx.duplicationResult)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _cache[31] || (_cache[31] = _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                "data-bs-dismiss": "modal",
                                id: "closeDuplicateModal"
                            }, [
                                _createElementVNode("i", { class: "fas fa-times me-2" }),
                                _createTextVNode("Annuler ")
                            ], -1)),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[11] || (_cache[11] =
                                    //@ts-ignore
                                    (...args) => (_ctx.triggerDuplication && _ctx.triggerDuplication(...args))),
                                disabled: _ctx.duplicationTargetRestaurants.length === 0
                            }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("i", { class: "fas fa-copy me-2" }, null, -1),
                                    _createTextVNode("Dupliquer ", -1)
                                ]))], 8, _hoisted_71)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.duplicationResult)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                "data-bs-dismiss": "modal",
                                onClick: _cache[12] || (_cache[12] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetDuplicationState && _ctx.resetDuplicationState(...args)))
                            }, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("i", { class: "fas fa-check me-2" }, null, -1),
                                    _createTextVNode("Fermer ", -1)
                                ]))])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ], 64));
}
